<template>

    <div class="container-fluid">

        <div id="accordion">
            <div class="card">
                <div class="card-header" v-on:click="show = !show">
                    <div class="row mb-3 px-3">
                        <div>
                            <button class="all-btn add-btn">{{$t("main.search")}} .... </button>
                        </div>
                        <div class="px-3">
                            <button class="all-btn" @click="searchByFilter">{{$t("main.search")}}
                            </button>
                        </div>
                        <div>
                            <button class="all-btn" @click.prevent="reportXslx()">
                                {{$t("accounting.account.report")}}
                            </button>
                        </div>
                    </div>
                </div>

                <div v-if="show" id="collapseOne" class="collapse show" data-parent="#accordion">
                    <div class="card-body">
                        <div class="row mb-3">

                            <div class="col-lg-2 col-md-3 col-sm-4"  v-if="organizationListValue.data && organizationListValue.data.length > 0">
                                <label>{{$t("accounting.account.organization")}}</label>
                                <select class="form-control" v-model="filter.organizationType"
                                        @change="onOrganizationTypeChange">
                                    <option value="" v-if="organizationListValue.data.length === organizationListValue.total"></option>
                                    <option :value="option.code" v-for="option in organizationListValue.data"
                                            :key="option.code">
                                        {{option.displayName}}
                                    </option>
                                </select>
                            </div>

                            <div class="col-lg-2 col-md-3 col-sm-4">
                                <label>{{$t("accounting.account.province")}}</label>
                                <v-select v-model="filter.province" label="name"
                                          :options="provinces"
                                          :filterable="false"
                                          @search="onProvinceGetRegionsChange"
                                          @change="onProvinceGetRegionsChange">
                                    <template slot="option" slot-scope="option" v-if="option">
                                        <div v-html="option.name"></div>
                                    </template>
                                    <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                </v-select>
                            </div>

                            <div class="col-lg-2 col-md-3 col-sm-4">
                                <label>{{$t("accounting.account.city")}} ва
                                    {{$t("accounting.account.district")}}</label>
                                <v-select v-model="filter.region" label="name"
                                          :options="regions"
                                          :filterable="false"
                                          @search="onRegionsChange"
                                          @change="onRegionsChange">
                                    <template slot="option" slot-scope="option" v-if="option">
                                        <div v-html="option.name"></div>
                                    </template>
                                    <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                </v-select>
                            </div>

                            <div class="col-lg-2 col-md-3 col-sm-4">
                                <label>{{$t("report.date.startDate")}}</label>
                                <datepicker
                                        class="form-control"
                                        format="dd/MM/yyyy"
                                        v-model="filter.startDate"
                                        :clear-button="true"
                                ></datepicker>
                            </div>

                            <div class="col-lg-2 col-md-3 col-sm-4">
                                <label>{{$t("report.date.endDate")}}</label>
                                <datepicker
                                        class="form-control"
                                        format="dd/MM/yyyy"
                                        v-model="filter.endDate"
                                        :clear-button="true"
                                ></datepicker>
                            </div>

                            <div class="col-lg-2 col-md-3 col-sm-4">
                                <label>{{$t("report.field.objectType")}}</label>
                                <select v-model="filter.objectType" class="form-control" @change="searchByFilter">
                                    <option disabled value="">{{$t("messages.combo.empty")}}</option>
                                    <option value="Auto" style="font-family:verdana;">Автотранспорт</option>
                                    <option value="Building">Бино-иншоатлар</option>
                                    <option value="Fitment">Асбоб-ускуналар</option>
                                </select>
                            </div>

                            <div class="col-lg-2 col-md-3 col-sm-4">
                                <label>{{$t("accounting.account.executiveJob")}}
                                    {{$t("accounting.account.number")}}</label>
                                <input type="text" class="form-control" v-model="filter.letterNumber"
                                       @change="searchByFilter"/>
                            </div>
                            <div class="col-lg-2 col-md-3 col-sm-4">
                                <label>{{$t("accounting.account.contract")}} {{$t("accounting.account.number")}}</label>
                                <input type="text" class="form-control" v-model="filter.generateNumberContract"
                                       @change="searchByFilter"/>
                            </div>
                            <div class="col-lg-2 col-md-3 col-sm-4">
                                <label>{{$t("accounting.account.invoice")}} {{$t("accounting.account.number")}}</label>
                                <input type="text" class="form-control" v-model="filter.invoiceNumber"
                                       @change="searchByFilter"/>
                            </div>
                            <div class="col-lg-2 col-md-3 col-sm-4">
                                <label>{{$t("accounting.account.report")}} {{$t("accounting.account.number")}}</label>
                                <input type="text" class="form-control" v-model="filter.generateNumberReport"
                                       @change="searchByFilter"/>
                            </div>
                            <div class="col-lg-2 col-md-3 col-sm-4">
                                <label>{{$t("accounting.account.identificationNumber")}}</label>
                                <input type="text" class="form-control" v-model="filter.identificationNumber"
                                       @change="searchByFilter"/>
                            </div>
                            <div class="col-lg-2 col-md-3 col-sm-4">
                                <label>{{$t("report.field.fullName")}} yoki
                                    {{$t("accounting.account.organization")}}</label>
                                <input type="text" class="form-control" v-model="filter.search" @change="searchByFilter"/>
                            </div>
                            <div class="col-lg-2 col-md-3 col-sm-4">
                                <label>{{$t("report.field.governmentNum")}}</label>
                                <input type="text" class="form-control" :placeholder="$t('report.field.car')" v-model="filter.governmentNum" @change="searchByFilter"/>
                            </div>
                            <div class="col-lg-2 col-md-3 col-sm-4">
                                <label>{{$t("report.field.paymentStatus")}}</label>
                                <select class="form-control" v-model="filter.paymentStatus">
                                    <option value="ALL">{{$t('report.field.paymentStatusAll')}}</option>
                                    <option value="PAID">{{$t('report.field.paymentStatusPaid')}}</option>
                                    <option value="UNPAID">{{$t('report.field.paymentStatusUnPaid')}}</option>
                                </select>
                            </div>

                            <div class="col-lg-2 col-md-3 col-sm-4">
                                <label>{{$t("report.field.salePropertyStatus")}}</label>
                                <select class="form-control" v-model="filter.saleProperty">
                                    <option value="NONE">{{$t('report.field.salePropertyStatusNONE')}}</option>
                                    <option value="SOLD">{{$t('report.field.salePropertyStatusSOLD')}}</option>
                                    <option value="NOSOLD">{{$t('report.field.salePropertyStatusUnPaid')}}</option>
                                </select>
                            </div>

                        </div>
                    </div>
                </div>

                <div v-if="evaluationObjectIds.length>0" class="collapse show" data-parent="#accordion">
                    <div class="card-body">
                        <div class="row pl-3 align-items-center">
                          <button class="all-btn add-btn" @click.prevent="sendRequirement()"
                                  v-if="hasPermission('LEGAL_REPORT_REQUIREMENT_MESSAGE')">{{$t("main.send")}}
                          </button>
                          <button class="all-btn ml-3"
                                  @click.prevent="requirementPdf()"
                                  v-if="hasPermission('LEGAL_REPORT_REQUIREMENT')">{{$t("accounting.account.requirement")}}
                          </button>

                          <div class="ml-3">
                            Мулклар: <strong>{{evaluationObjectIds}}</strong>
                          </div>
                        </div>
                    </div>
                </div>

                <div v-if="selectedEvaluationObject.length>0" id="soldoDate" class="collapse show"
                     data-parent="#accordion">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-4">
                                <datepicker
                                        class="form-control"
                                        format="dd/MM/yyyy"
                                        v-model="salePropertyDto.tradingDay"
                                        placeholder="Савдо куни"
                                        :clear-button="true"
                                ></datepicker>
                            </div>
                            <div class="col-sm-4 my-2 my-sm-0">
                                <input type="text" placeholder="Лот рақами" class="form-control"
                                       v-model="salePropertyDto.numberLot"/>
                            </div>
                            <div class="col-sm-3">
                                <button class="all-btn pull-right m-0" @click.prevent="saveSalesDay()">
                                    {{$t("action.save")}}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="selectedNumberLot.length>0" id="salesDay" class="collapse show" data-parent="#accordion">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-4">
                                <datepicker
                                        class="form-control"
                                        format="dd/MM/yyyy"
                                        v-model="salePropertyDto.saleDate"
                                        placeholder="Сотилган сана"
                                        :clear-button="true"
                                ></datepicker>
                            </div>
                            <div class="col-sm-4 my-2 my-sm-0">
                                <numeric-input type="text" placeholder="Сотилган нарх" class="form-control"
                                               v-model="salePropertyDto.price"/>
                            </div>
                            <div class="col-sm-3">
                                <button class="all-btn pull-right" @click.prevent="saveSalesDay()">
                                    {{$t("action.save")}}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body scroll-card-body table-responsive">
                        <table class="customers">
                            <thead>
                            <tr>
                                <th rowspan="3">
                                    {{$t("main.number")}}
                                </th>
                                <th rowspan="3">
                                    {{$t("report.field.objectNumber")}}
                                </th>
                                <th colspan="10">
                                    {{organization}}
                                </th>
                                <th colspan="2">
                                    {{$t("accounting.account.order")}}
                                </th>
                                <th colspan="3">
                                    {{$t("accounting.account.report")}}
                                </th>
                                <th colspan="6">
                                    {{$t("accounting.account.invoice")}}
                                </th>
                                <th rowspan="3">
                                    {{$t("accounting.account.totalAmountQQS")}}
                                </th>
                                <th colspan="4">
                                    {{$t("accounting.account.saleProperty")}}
                                </th>
                                <th colspan="2">
                                    {{$t("accounting.account.paymentOfLastDate")}}
                                </th>
                                <th colspan="2">
                                    {{$t("accounting.account.numberDaysLastDatePayment")}}
                                </th>
                                <th colspan="2">
                                    {{$t("accounting.account.numberBorrowerDays")}}
                                </th>
                                <th colspan="3">
                                    {{$t("accounting.account.paymentDocument")}}
                                </th>
                                <th colspan="2">
                                    {{$t("accounting.account.residualBorrowingPennyFineLossNotIncluded")}}
                                </th>
                                <th colspan="5">
                                    {{$t("accounting.account.paymentDelayed")}}
                                </th>
                                <th colspan="6">
                                    {{$t("accounting.account.requirement")}}
                                </th>
                                <th colspan="2">
                                    {{$t("accounting.account.residualBorrowingPennyFineLossAlongWith")}}
                                </th>
                            </tr>
                            <tr>
                                <th rowspan="2">{{$t("report.field.organization")}}</th>
                                <th rowspan="2">{{$t("report.field.province")}}</th>
                                <th rowspan="2">{{$t("accounting.account.districtAndCity")}}</th>
                                <th rowspan="2">{{$t("accounting.account.fullName")}}</th>
                                <th colspan="2">{{$t("accounting.account.executiveJob")}}</th>
                                <th rowspan="2">{{$t("accounting.account.passportNumber")}}</th>
                                <th rowspan="2">{{$t("accounting.account.identificationNumber")}}</th>
                                <th rowspan="2">{{$t("accounting.account.bankMFO")}}</th>
                                <th rowspan="2">{{$t("accounting.account.accountNumber")}}</th>
                                <th rowspan="2">{{$t("accounting.account.number")}}</th>
                                <th rowspan="2">{{$t("accounting.account.date")}}</th>
                                <th rowspan="2">{{$t("accounting.account.number")}}</th>
                                <th rowspan="2">{{$t("accounting.account.date")}}</th>
                                <th rowspan="2">{{$t("accounting.account.feeService")}}</th>
                                <th rowspan="2">{{$t("accounting.account.number")}}</th>
                                <th rowspan="2">{{$t("accounting.account.date")}}</th>
                                <th rowspan="2">{{$t("accounting.account.jobName")}}</th>
                                <th rowspan="2">{{$t("accounting.account.priceWithoutQQS")}}</th>
                                <th colspan="2">{{$t("accounting.account.qqs")}}</th>
                                <th rowspan="2">{{$t("accounting.account.propertyType")}}</th>
                                <th rowspan="2">{{$t("accounting.account.numberLot")}}</th>
                                <th rowspan="2">{{$t("accounting.account.saleDate")}}</th>
                                <th rowspan="2">{{$t("accounting.account.salesDateAndPrice")}}</th>
                                <th rowspan="2">{{$t("accounting.account.accordingContract")}}</th>
                                <th rowspan="2">{{$t("accounting.account.decision1154")}}</th>
                                <th rowspan="2">{{$t("accounting.account.accordingContract")}}</th>
                                <th rowspan="2">{{$t("accounting.account.decision1154")}}</th>
                                <th rowspan="2">{{$t("accounting.account.accordingContract")}}</th>
                                <th rowspan="2">{{$t("accounting.account.decision1154")}}</th>
                                <th rowspan="2">{{$t("accounting.account.number")}}</th>
                                <th rowspan="2">{{$t("accounting.account.date")}}</th>
                                <th rowspan="2">{{$t("accounting.account.totalAmount")}}</th>
                                <th rowspan="2">{{$t("accounting.account.debtor")}}</th>
                                <th rowspan="2">{{$t("accounting.account.creditor")}}</th>
                                <th rowspan="2">{{$t("accounting.account.numberDays")}}</th>
                                <th rowspan="2">{{$t("accounting.account.totalAmount")}}</th>
                                <th colspan="3">{{$t("accounting.account.calculated")}}</th>
                                <th rowspan="2">{{$t("accounting.account.number")}}</th>
                                <th rowspan="2">{{$t("accounting.account.date")}}</th>
                                <th rowspan="2">{{$t("accounting.account.totalAmount")}}</th>
                                <th colspan="3">{{$t("accounting.account.including")}}</th>
                                <th rowspan="2">{{$t("accounting.account.debtor")}}</th>
                                <th rowspan="2">{{$t("accounting.account.creditor")}}</th>


                            </tr>
                            <tr>
                                <th>{{$t("accounting.account.number")}}</th>
                                <th>{{$t("accounting.account.date")}}</th>

                                <th>{{$t("accounting.account.qqsRate")}}</th>
                                <th>{{$t("accounting.account.qqsAmount")}}</th>

                                <th>{{$t("accounting.account.pricePenny")}}</th>
                                <th>{{$t("accounting.account.priceFine")}}</th>
                                <th>{{$t("accounting.account.lostProfitOrDamage")}}</th>

                                <th>{{$t("accounting.account.principalDebt")}}</th>
                                <th>{{$t("accounting.account.priceFine")}}</th>
                                <th>{{$t("accounting.account.pricePenny")}}</th>

                            </tr>
                            </thead>
                            <tbody>
                            <template v-if="results">
                                <tr v-for=" (result, index) in results.data" :key="result.id" :class="[result.sendRequirementBoolean ? 'tdpaid':'']">

                                    <td>
<!--                                        <input type="checkbox" :value="result.id" v-model="evaluationObjectIds" :disabled="!result.identificationNumber">-->
<!--                                        &nbsp;&nbsp;&nbsp;&nbsp; {{index+1}}-->
                                      <div class="custom-control custom-checkbox">
                                        <input type="checkbox" class="custom-control-input" :id="'evaluationObjectId' + result.id" :value="result.id" :disabled="!result.identificationNumber"
                                               v-model="evaluationObjectIds"
                                               />
                                        <label class="custom-control-label" :for="'evaluationObjectId' + result.id">{{index+1}}</label>
                                      </div>
                                    </td>
                                    <td>
<!--                                        <input type="checkbox" :value="result.id" v-model="selectedEvaluationObject"
                                               @change='updateCheckEvaluationObject()'>
                                            <a :href="getOpenLink(result)" target="_blank">{{result.id}}</a>-->

                                        <div class="custom-control custom-checkbox">
                                          <input type="checkbox" class="custom-control-input" :id="'selectedEvaluationObject' + result.id" :value="result.id"
                                                 v-model="selectedEvaluationObject" @change='updateCheckEvaluationObject()'
                                          />
                                          <label class="custom-control-label" :for="'selectedEvaluationObject' + result.id">
                                            <a :href="getOpenLink(result)" target="_blank">{{result.id}}</a>
                                          </label>
                                        </div>

                                    </td>
                                    <td>{{result.clientName}}</td>
                                    <td>{{result.province}}</td>
                                    <td>{{result.region}}</td>
                                    <td :title="result.fullName">{{result.fullNameTitle}}</td>
                                    <td>{{result.letterNumber}}</td>
                                    <td>{{result.letterDate}}</td>
                                    <td :title="result.passportNumber">{{result.passportNumberTitle}}</td>
                                    <td>{{result.identificationNumber}}</td>
                                    <td>{{result.bankMFO}}</td>
                                    <td>{{result.accountNumber}}</td>
                                    <td>{{result.generateNumberContract}}</td>
                                    <td>{{result.generateDateContract}}</td>
                                    <td>{{result.generateNumberReport}}</td>
                                    <td>{{result.generateDateReport}}</td>
                                    <td>{{result.contractAmount | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                    <td>{{result.generateNumberContract}}</td>
                                    <td>{{result.generateDateReport}}</td>
                                    <td>{{result.jobName}}</td>
                                    <td>{{result.contractAmount | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                    <td>{{result.qqsRate | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                    <td>{{result.qqsAmount | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                    <td>{{result.totalAmountQQS | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                    <td>{{result.objectType}}</td>
                                    <td>
<!--                                        <input v-if="result.numberLot!=null" type="checkbox" :value="result.numberLot"
                                               v-model="selectedNumberLot"
                                               @change='updateCheckNumberLot()'>
                                        &nbsp;&nbsp;&nbsp;&nbsp; {{result.numberLot}}-->

                                        <div class="custom-control custom-checkbox" v-if="result.numberLot!=null">
                                          <input type="checkbox" class="custom-control-input" :id="'selectedNumberLot' + result.id" :value="result.numberLot"
                                                 v-model="selectedNumberLot" @change='updateCheckNumberLot()'
                                          />
                                          <label class="custom-control-label" :for="'selectedNumberLot' + result.id">
                                            {{result.numberLot}}
                                          </label>
                                        </div>
                                    </td>
                                    <td>{{result.saleDate}}</td>
                                    <td>{{result.salesDateAndPrice}}</td>
                                    <td>{{result.accordingContractPaymentPeriodOne}}</td>
                                    <td>{{result.accordingContractPaymentPeriodTwo}}</td>
                                    <td>{{result.numberDaysLastDatePaymentOne}}</td>
                                    <td>{{result.numberDaysLastDatePaymentTwo}}</td>
                                    <td>{{result.numberBorrowerDaysOne}}</td>
                                    <td>{{result.numberBorrowerDaysTwo}}</td>
                                    <td>{{result.paymentDocumentNumber}}</td>
                                    <td>{{result.paymentDocumentDate}}</td>
                                    <td>{{result.paid | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                    <td>{{result.debtor | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                    <td>{{result.creditor | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                    <td>{{result.numberBorrowerDaysOne}}</td>
                                    <td>{{result.unpaid | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                    <td>{{result.pricePenny | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                    <td>{{result.priceFine | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                    <td>{{result.lostProfit}}</td>
                                    <td>{{result.requirementNumber}}</td>
                                    <td>{{result.requirementDate}}</td>
                                    <td>{{result.totalPricePennyFineProfitUnpaid | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                    <td>{{result.unpaid | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                    <td>{{result.pricePenny | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                    <td>{{result.lostProfit}}</td>
                                    <td>{{result.totalPricePennyFineProfitUnpaid | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                    <td>{{result.creditor | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                </tr>
                            </template>
                            </tbody>
                            <tfoot class="table-footer">
                            <tr v-if="loadingTotal">
                                <loading2 style="" v-if="loadingTotal"></loading2>
                            </tr>
                            <tr v-if="!loadingTotal">
                                <td colspan="16">{{tableTotalValue.evaluationObjTotal}}</td>
                                <td colspan="4">{{tableTotalValue.contractTotal | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                <td>{{tableTotalValue.evaluationTotal | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                <td></td>
                                <td>{{tableTotalValue.totalVat | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                <td colspan="1">{{tableTotalValue.totalContractQQS | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                <td colspan="12"></td>
                                <td colspan="1">{{tableTotalValue.peidTotal | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                <td colspan="1">{{tableTotalValue.unpeidTotal | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                <td colspan="1">{{tableTotalValue.creditorTotal | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                <td colspan="1"></td>
                                <td colspan="1">{{tableTotalValue.unpeidTotal | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                <td colspan="1">{{tableTotalValue.pennyTotal | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                <td colspan="1">{{tableTotalValue.fineTotal | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                <td colspan="1">{{tableTotalValue.damageTotal | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                <td colspan="2"></td>
                                <td colspan="1">{{tableTotalValue.pennyAndFineAnddamageTotal | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                <td colspan="1">{{tableTotalValue.unpeidTotal | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                <td colspan="1">{{tableTotalValue.fineTotal | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                <td colspan="1">{{tableTotalValue.pennyTotal | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                <td colspan="1">{{tableTotalValue.unpeidPennyAndFineAndDamageTotal | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                <td colspan="1">{{tableTotalValue.creditorTotal | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                            </tr>
                            </tfoot>
                        </table>
                    </div>
                    <div class="text-center">
                        <div class="loader mt-5 mb-5" v-if="loading"></div>
                        <span class="no-data mt-5 mb-5"
                              v-if="!loading && results && results.data && results.data.length===0">{{$t("messages.list.empty")}}</span>
                    </div>
                    <div class="row" v-if="!loading && results && results.total && results.total > 1 ">
                        <div class="col-12 pt-3 pb-3">
                            <b-pagination :total-rows="results.total" v-model="filter.page.page"
                                          :per-page="filter.page.size" @change="onPageChange">
                            </b-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>


</template>
<script>
    import Datepicker from 'vuejs-datepicker';
    import bPagination from 'bootstrap-vue/es/components/pagination/pagination';
    import initFilterModel from '@/shared/filter';
    import {formatDate, parseDate} from '@/shared/utils';
    import Loading2 from '@/views/Loading2';

    // export const
    export default {
        name: "AccountingLegalAndPhysical",
        components: {
            'b-pagination': bPagination,
            Datepicker,
            Loading2
        },
        data() {
            return {
                loading: false,
                loadingTotal: true,
                show: false,
                filter: initFilterModel(),
                results: null,
                organization: this.$t("accounting.account.organization"),
                evaluationObjectIds: [],
                organizationListValue: {},
                regions: [],
                provinces: [],
                salePropertyDto: {},
                selectedEvaluationObject: [],
                selectedNumberLot: [],
                tableTotalValue: [],
            }
        },
        methods: {
            searchByFilter() {
                this.filter.page.page = 1;
                this.initList();
            },
            initList() {
                this.loading = true;
                this.init();
                this.filter.startDate = formatDate(this.filter.startDate);
                this.filter.endDate = formatDate(this.filter.endDate);
                this.filter.startDate = parseDate(this.filter.startDate);
                this.filter.endDate = parseDate(this.filter.endDate);
                console.log(this.filter);

                this.$http.post('legal/list', this.filter)
                    .then(res => {
                        this.results = res.data;
                        this.initTableTotal();
                        this.loading = false;
                    }, err => {
                        console.log(err);
                        this.loading = false;
                    });
            },
            onPageChange(page) {
                this.filter.page.page = page;
                this.initList();
            },
            initTableTotal() {
                const vm = this;
                vm.loadingTotal = true;
                const promises = [
                    this.$http.post('/legal/data/total', this.filter)
                ];
                Promise.all(promises).then(function (values) {
                    const initData = values[0].data;
                    vm.tableTotalValue = initData.dataTotal;
                    vm.loadingTotal = false;

                });
            },
            getOrganizationType() {
                const vm = this;
                this.loading = true;
                this.$http.get('/account/organizationType')
                    .then(res => {
                        const initData = res.data;
                        if (!vm.filter.organizationType && initData.data && initData.data.length < initData.total && initData.data.length > 0) {
                            vm.filter.organizationType = initData.data[0].code;
                            vm.organization = initData.data[0].displayName
                        }
                        vm.organizationListValue = initData;
                        this.initList();
                        vm.loading = false;
                    }, (err) => {
                        console.log(err);
                        vm.loading = false;
                    });
            },
            init() {
                const vm = this;
                const promises = [
                    this.$http.get('province/init')
                ];
                Promise.all(promises).then(function (values) {
                    const initData = values[0].data;
                    vm.provinces = initData.provinces;
                });
            },

            updateCheckEvaluationObject: function () {
                if (this.selectedEvaluationObject.length > 1) {
                    this.$delete(this.selectedEvaluationObject, 0);
                }
                this.salePropertyDto.evaluationObjectId = this.selectedEvaluationObject[0];
            },
            updateCheckNumberLot: function () {
                if (this.selectedNumberLot.length > 1) {
                    this.$delete(this.selectedNumberLot, 0);
                }
                this.salePropertyDto.numberLot = this.selectedNumberLot[0];
            },
            saveSalesDay: function () {
                this.loading = true;
                this.$http.post('/sale/property/save/', this.salePropertyDto).then(res => {
                    this.loading = false;
                    if (res.data) {
                        this.$swal({
                            title: this.$t('messages.common.success'),
                            text: this.$t('messages.building.success'),
                            type: 'success'
                        });
                    }
                }, err => {
                    console.log(err);
                });

            },
            onProvinceGetRegionsChange() {
                let regions = [];
                this.evaluationObjectIds=[];
                if (this.filter.province && this.filter.province.id && this.provinces && this.provinces.length > 0) {
                    this.provinces.forEach((province) => {
                        if (province.id === this.filter.province.id) {
                            regions = province.regions;
                        }
                    });
                }
                this.regions = regions;
                // this.filter.region = null;
                this.searchByFilter();
            },
            onRegionsChange() {
                this.evaluationObjectIds=[];
                this.searchByFilter();
            },
            onOrganizationTypeChange() {
                let organization = null;
                if (this.filter.organizationType==null || this.filter.organizationType==='') {
                    this.$delete(this.filter, 'organizationType');
                }
                this.evaluationObjectIds=[];
                if (this.filter.organizationType && this.organizationListValue.data && this.organizationListValue.data.length > 0) {
                    this.organizationListValue.data.forEach((organizationListValue) => {
                        if (organizationListValue.code === this.filter.organizationType) {
                            organization = organizationListValue.displayName;
                        }
                    });
                }
                this.organization = organization;
                this.searchByFilter();
            },
            sendRequirement: function () {
                this.$http.get('/send/message/file/' + this.evaluationObjectIds.toString())
                    .then(res => {
                        this.$swal({
                            title: this.$t('messages.common.success'),
                            text: this.$t('accounting.accountMessages.success'),
                            type: 'success'
                        });
                        console.log(res.data);
                    }, err => {
                        this.$swal({
                            title: this.$t('messages.common.error'),
                            text: this.$t('accounting.accountMessages.error'),
                            type: 'error'
                        });
                        console.log(err);
                    });
            },
            requirementPdf: function () {
                this.$http.get('/requirementReport/pdf/' + this.evaluationObjectIds.toString() + '/WITH_SIGNATURE', {responseType: 'arraybuffer'})
                    .then(response => {

                        let blob = new Blob([response.data], {type: 'application/pdf'});
                        let link = document.createElement("a");
                        link.href = window.URL.createObjectURL(blob);
                        link.download = 'Талабнома.pdf';
                        link.click()
                    })
            },
            reportXslx: function () {
                this.$http.post('/getAccountingReportExcel/xls/FITMENT_REPORT_VALUABLE_XLS/',this.filter, {responseType: 'arraybuffer'})
                    .then(res => {
                        let blob = new Blob([res.data], {type: 'application/xlsx'});
                        let link = document.createElement("a");
                        link.href = window.URL.createObjectURL(blob);
                        link.download = 'Xisobot.xlsx';
                        link.click();
                    }, err => {
                        console.log(err);
                    });
            },
            getOpenLink(result) {
                if (result.evlObjectTypeDto.code === 'Auto') {
                    return process.env.VUE_APP_WEB_URL + 'automulti/view?autoId=' + result.id;
                } else if (result.evlObjectTypeDto.code === 'Fitment') {
                    return process.env.VUE_APP_WEB_URL + 'fitment/view/' + result.id;
                }
                return "";
            },


        },

        created() {
            // this.initList();
            var d = new Date();
            var currMonth = d.getMonth();
            var currYear = d.getFullYear();
            this.filter.startDate = new Date(currYear, currMonth, 1);
            this.filter.endDate = new Date(currYear, currMonth, d.getDate());

            this.getOrganizationType();
        },
    }
</script>
<style>
    .scroll-card-body {
        overflow-x: scroll;
        overflow-y: visible;
    }

    td {
        border-top: 1px solid #dee2e6;
    }

    th, td {
        padding: .5rem;
        /*cursor: col-resize;*/
        white-space: nowrap;
    }

    .tdpaid {
        color: red;
    }

    .tdunpaid {
        background-color: transparent;
    }
</style>

